import { axiosInstance as axios } from "services";

export const fetchPendingChanges = async (type) => {
  const { data } = await axios.get(`/pricing/master/sync-status/pending-changes?type=${type}`);
  if (!data.success) throw new Error(data.error?.message || "Failed to fetch pending items");
  return data.result;
};
